import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const BestCollection = () => {
  return (
    <div className="product-bestsale-jewelry hidden-xs">
        <div className="container">
            <div className="title-box2 text-center main_heading">
                <h2 className="title30 dark text-uppercase">Best Collections</h2>
            </div>

            <div className="filter-catelog">
                <ul className="best_seller_ul">
                    <li className="cateli_main aos-init aos-animate" data-aos="fade-down" data-aos-duration="1500">
                        <Link to="/ringsettings">
                            <div className="catimg_main">
                                <LazyLoadImage src={`${ImageUrl}theme/tokyo/engagement_rings.jpg`} alt='' /> 
                            </div>
                        </Link>		
                        <p> Engagement Rings</p>
                    </li>

                    <li className="cateli_main aos-init aos-animate" data-aos="fade-down" data-aos-duration="1900">
                        <Link to="/jewelry/wedding-rings">
                            <div className="catimg_main">
                                <LazyLoadImage src={`${ImageUrl}theme/tokyo/wedding_rings.jpg`} alt='' /> 
                            </div>
                        </Link>					
                        <p className="white"> Wedding Rings</p>

                    </li>
                    
                    <li className="cateli_main aos-init aos-animate" data-aos="fade-down" data-aos-duration="2300">
                        <Link to="/jewelry/earrings">
                            <div className="catimg_main">
                                <LazyLoadImage src={`${ImageUrl}theme/tokyo/earrings.jpg`} alt=''/> 
                            </div>
                        </Link>
                        <p> Earrings</p>
                    </li>

                    <li className="cateli_main aos-init aos-animate" data-aos="fade-down" data-aos-duration="2700">
                        <Link to="/jewelry/bracelets">
                            <div className="catimg_main">
                                <LazyLoadImage src={`${ImageUrl}theme/tokyo/bracelets.jpg`} alt='' /> 
                            </div>
                        </Link>
                        <p className="white"> Bracelets</p>
                    </li> 
                    
                    <li className="cateli_main aos-init aos-animate" data-aos="fade-down" data-aos-duration="3000">
                        <Link to="/jewelry/necklace">
                            <div className="catimg_main">
                                <LazyLoadImage src={`${ImageUrl}theme/tokyo/necklase.jpg`} alt='' /> 
                            </div>
                        </Link>
                        <p> Necklaces </p>
                    </li>
                </ul>
            </div>
        </div>		
	</div>
  )
}

export default BestCollection